import { render, staticRenderFns } from "./plan_rank.vue?vue&type=template&id=994dd59c&scoped=true&"
import script from "./plan_rank.vue?vue&type=script&lang=js&"
export * from "./plan_rank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994dd59c",
  null
  
)

export default component.exports